<template>
  <o-panel-link
    :path="`/waitlist/${waitlist.idWaitlist}`"
    class="p-2 transition duration-300"
  >
    <div class="w-full relative flex items-center justify-between">
      <div class="flex items-center">
        <div
          class="flex flex-col self-stretch w-2 mr-4 rounded overflow-hidden divide-y-1 divide-white"
        >
          <div
            v-for="service in waitlist.services"
            :key="`${waitlist.idWaitlist}-${service.service.idService}`"
            class="w-full flex-grow"
            :style="{
              backgroundColor: '#' + service.service.borderHexColour
            }"
          />
        </div>
        <div class="w-full py-1">
          <p v-if="waitlist.dates?.length" class="text-sm">
            {{ waitlist.datesLabel.join(', ') }}
          </p>
          <p class="text-base font-semibold leading-tight md:leading-loose my-1 md:my-0">
            {{ waitlist.servicesLabel }}
          </p>
          <div class="text-sm opacity-80 flex flex-wrap leading-none">
            <span class="flex items-center mr-3 mb-1 leading-tight">
              <!--<o-avatar :items="employees" class="hidden md:flex pr-2" />-->
              <span>{{ employeesLabel }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap justify-end items-center">
        <o-chip v-if="waitlist.status != null" :variant="statusColour" flat>
          {{ $t(WaitlistStatusLabels[waitlist.status as WaitlistStatus] || '') }}
        </o-chip>
      </div>
    </div>
  </o-panel-link>
</template>

<script setup lang="ts">
import { WaitlistStatus, WaitlistStatusLabels } from '~/_api/models/waitlist'

interface Props {
  waitlist: Record<string, any>
}

const props = defineProps<Props>()

const { $i18n } = useNuxtApp()

const employeesLabel = computed(() => {
  const services = props.waitlist.services

  const labels = services
    .map((service: any) => {
      return service.employee ? service.employee.displayName : $i18n.t('service.firstAvailable')
    })
    .filter((value: any, index: number, array: any[]) => {
      return array.indexOf(value) === index
    })

  return labels.join(', ')
})

const statusColour = computed(() => {
  switch (props.waitlist.status) {
    case WaitlistStatus.waiting:
      return 'warning'
    case WaitlistStatus.booked:
      return 'success'
    case WaitlistStatus.offered:
    case WaitlistStatus.notified:
      return 'success'
    case WaitlistStatus.alerted:
      return 'warning'
    case WaitlistStatus.expired:
    case WaitlistStatus.cancelled:
      return 'danger'
    default:
      return null
  }
})

const waitlistProps = computed(() => {
  const waitlist = props.waitlist
  const customer = waitlist.customer

  return {
    presets: {
      waitlist,
      customer,
    },
  }
})
</script>
